import React from 'react';
import PropTypes from 'prop-types';
import menuSVG from './actions.svg';

const PopdownButton = ({ tileId }) => (
  <li
    className="pill more right"
    data-tip={true}
    data-for={`dropdown-${tileId}`}
    data-event="click"
  >
    <img
      alt="menu"
      src={menuSVG}
      style={{ height: '18px', marginTop: '2px' }}
    />
  </li>
);

PopdownButton.propTypes = {
  tileId: PropTypes.string.isRequired,
};

export default PopdownButton;
